module.exports = __webpack_public_path__ + "img/user.3af6bc5e.jpg";